import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HydraCollection } from '../hydra/hydra-collection';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class TrainingPlanCourseDateApiService extends ApiService {
  readonly resourcePath = 'training_plan_course_dates';

  list(params: Record<string, any>): Observable<HydraCollection<any>> {
    return this.restList(params);
  }
  
  bulkUpdate(data:object ){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/merge-patch+json'
      })
    };
    return this.http.patch<any>(this.resourceUrl +'/bulk_update',data, httpOptions);
  }

}
